export { ApproveBatch as default } from '@/screens/batches/ApproveBatch'
